module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular-Italic.f45d04d0.woff2";